module.exports = __webpack_public_path__ + "img/pr-1.38b91dcb.png";